
import { modal, route } from './platform/index'
import { uploadMonitor } from './api/upload'
import { getDeviceName } from './utils/device'
import { getClickEvent } from './utils/index'

import vue from '@/main'

// 埋点配置项
const _options = {
  debug: false, // 是否开启debug
  system: 'h5', // 可选值： h5 | web
  monitorType: '', // 标签埋点绑定分 v-monitor | monitor，可选值 vue | other
  vue: null, // Vue v-monitor 专用
  logUrl: '',
  isTrackSinglePage: false // 是否开启单页应用埋点
}

// 埋点基本参数 SPA 外部注入，异步处理
let _params = {}

// debug弹窗
function debugAlert (tips) {
  if (_options.debug === true) {
    modal.alert(tips)
  }
}

const monitor = {
  install (options) {
    const systemInfo =  getDeviceName()
    _params = Object.assign({}, {
      source: 'H5',
      deviceName: systemInfo.deviceName,
      browserName: systemInfo.browserName
    })

    if (options && typeof options === 'object') {
      _options.debug = (options.debug === true)
      options.logUrl && (_options.logUrl = options.logUrl)
    }
    debugAlert('初始化成功')
  },
  visit (urlData, event, extraParams, success, fail) {
    // 存储 referUrl 到 sessionStorage 中
    if (urlData.refer_url) {
      window.sessionStorage.setItem('_refer_url_', urlData.refer_url)
    }
    this.click(event, extraParams, success, fail)
  },
  click (masterData, extraParams, success, fail) {
    // console.log('禁止访问埋点: ', masterData.monitorForbid)
    if (masterData.monitorForbid) return
    if (vue && vue.$route && vue.$route.query && vue.$route.query.monitorForbid) return // monitorForbid=1

    delete masterData.monitorForbid
    const masterParams = getClickEvent(masterData)
    const args = Object.assign({}, _params, {
      url: route.getCurrentRoute(),
      referUrl: route.getReferUrl(), // 来源,
      privateParamsMap: extraParams, // 私有参数
      channel: localStorage.getItem('channel') || 'hy',
      ...masterParams
    })
    const options = { logUrl: _options.logUrl }

    // console.log('埋点上报: ', args, options)
    // 生成埋点接口参数
    setTimeout(() => {
      uploadMonitor(args, options, function (response) {
        typeof success === 'function' && success(response)
        debugAlert('点击埋点上报成功')
      }, function (error) {
        typeof fail === 'function' && fail(error)
        debugAlert('点击埋点上报失败')
      })
    }, 0)
  }
}

export default monitor



// WEBPACK FOOTER //
// ./src/npm/monitor/index.js